module.exports = __webpack_public_path__ + "media/images/icons/pin-5099b9d5892089bd495780f13915ad80.svg";